import { USER_ROLES } from 'constants/AuthConstant';

export const ROLES = {
  ADMIN: 'ROLE_ADMIN',
  USER: 'ROLE_USER',
};

/** User list / add / edit / delete — admin only. */
export const ROLE_USER_MANAGEMENT_ADMIN_ONLY = [ROLES.ADMIN];

/** @deprecated Use ROLE_USER_MANAGEMENT_ADMIN_ONLY for user-management routes. */
export const ROLE_ADMIN_ONLY = ROLE_USER_MANAGEMENT_ADMIN_ONLY;

/** Full platform access except user management (Admin and User roles). */
export const ROLE_FULL_ACCESS = [ROLES.ADMIN, ROLES.USER];

/** Dashboard, campaigns, reports, resources, and admin config for Admin and User. */
export const ROLE_STANDARD_ACCESS = ROLE_FULL_ACCESS;

export const getUserRoles = () => {
  try {
    const raw = localStorage.getItem(USER_ROLES);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const isAdmin = (roles = getUserRoles()) =>
  roles.includes(ROLES.ADMIN);

export const isUser = (roles = getUserRoles()) =>
  !isAdmin(roles) && roles.includes(ROLES.USER);

export const hasRouteAccess = (userRoles, requiredRoles) => {
  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }
  if (isAdmin(userRoles)) {
    return true;
  }
  return requiredRoles.some((role) => userRoles.includes(role));
};

export const filterNavByRole = (navItems, userRoles) =>
  navItems
    .map((item) => {
      if (item.roles && !hasRouteAccess(userRoles, item.roles)) {
        return null;
      }
      const submenu = item.submenu?.length
        ? filterNavByRole(item.submenu, userRoles)
        : [];
      if (item.isGroupTitle && submenu.length === 0) {
        return null;
      }
      return { ...item, submenu };
    })
    .filter(Boolean);
